/**
 * Under a Merlin reply that drafted questions: "🙋 Drafted a question to
 * Cliff Platt · ✓ sent", the chip read live from the case's asks, so the
 * chat stops saying "not sent" once the ask has gone (proposal 2, kanban
 * 31f2809d).
 *
 * A draft's chip is a button (UX round 2026-10-13): Merlin said "approve it
 * (press Send)" and the explorer clicked "not sent yet" expecting the draft;
 * nothing happened. It now jumps to the draft and its Send button.
 */
import { trackEvent } from '../../services/portalTracking';
import type { AskToolLine } from './askChipView';
import styles from './AskToolChips.module.css';

export interface AskToolChipsProps {
  lines: AskToolLine[];
  /** Where the drafts sit with their Send button (an element id). */
  draftsTargetId?: string;
  /** The item or case the chat sits on, recorded with the click. */
  trackContext?: Record<string, unknown>;
}

export function AskToolChips({ lines, draftsTargetId = 'case-asks', trackContext }: AskToolChipsProps) {
  if (lines.length === 0) return null;
  return (
    <ul className={styles.list} data-testid="ask-tool-chips">
      {lines.map((line) => (
        <li key={line.key} className={styles.line}>
          <span aria-hidden="true">🙋</span> Drafted a question to {line.target}
          {line.chip?.key === 'draft' ? (
            <button
              type="button"
              className={`${styles.chip} ${styles.chipButton}`}
              data-chip="draft"
              data-testid="ask-tool-chip"
              onClick={() => {
                trackEvent('action', 'qcp_chat_draft_chip', {
                  ...trackContext,
                  target: line.target,
                  result: 'scrolled_to_draft',
                });
                document.getElementById(draftsTargetId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}
            >
              not sent yet: review and send ↓
            </button>
          ) : (
            line.chip && (
              <span className={styles.chip} data-chip={line.chip.key} data-testid="ask-tool-chip">
                {line.chip.text}
              </span>
            )
          )}
        </li>
      ))}
    </ul>
  );
}

export default AskToolChips;
